import { defineComponent as _defineComponent } from 'vue'
import type { ChicletBackgroundColor } from '@@/bits/chiclet_color'
import OzAvatar from '@@/library/v4/components/OzAvatar.vue'
import OzBadge, { OzBadgeColorScheme } from '@@/library/v4/components/OzBadge.vue'
import OzBaseButton from '@@/library/v4/components/OzBaseButton.vue'
import OzIcon from '@@/library/v4/components/OzIcon.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ChicletButton',
  props: {
    iconName: { default: '' },
    iconStrokeWidth: { default: undefined },
    color: { default: 'green' },
    disabled: { type: Boolean, default: false },
    avatarUrl: { default: '' },
    avatarAltText: { default: '' },
    xNewBadge: { type: Boolean, default: false },
    text: { default: '' },
    subtext: { default: '' }
  },
  emits: ["click"],
  setup(__props: any) {

const props = __props as { iconName: string, iconStrokeWidth: number, color: ChicletBackgroundColor, disabled: boolean, avatarUrl: string, avatarAltText: string, xNewBadge: boolean, text: string, subtext: string };




const iconStrokeWidthStyle = computed(() =>
  props.iconStrokeWidth ? { '-webkit-text-stroke-width': `${props.iconStrokeWidth}px` } : {},
)

const iconColorClasses = computed(() => {
  switch (props.color) {
    case 'green':
      return ['text-park']
    case 'orange':
      return ['text-tangerine']
    case 'pink':
      return ['text-padlet-pink']
    case 'blue':
      return ['text-oceanic']
    case 'purple':
      return ['text-grape']
    case 'teal':
      return ['text-teal']
    default:
      return []
  }
})

return { __sfc: true,props, iconStrokeWidthStyle, iconColorClasses, OzAvatar, OzBadge, OzBadgeColorScheme, OzBaseButton, OzIcon }
}

})